// extracted by mini-css-extract-plugin
module.exports = {"linking-orders":"BEDeo2HV","linkingOrders":"BEDeo2HV"};